import type { UserRole } from '../../core/stores/user.store';

/**
 * Product-aware default landing route for a role. iLit20 teachers land on
 * Organizer (they have no Planner tab); other teachers on Planner; everyone
 * else on Library. Shared by `redirectToRoleLanding` (app.routes.ts) and
 * `ClassPickerComponent.roleLandingRoute()`.
 */
export function roleLandingRoute(role: UserRole, isIlit20: boolean): string {
  if (role !== 'teacher') return '/library';
  return isIlit20 ? '/organizer' : '/planner';
}
